<!--AFFICHAGE BLOC HEADER -->
<template>




        <v-container fluid v-if="this.condition()">
          <v-row dense>
            <v-col lg="5" md="12" sm="12">
              <UniteLegale v-bind:etablissement="etablissement"></UniteLegale>
              <Etablissement v-bind:etablissement="etablissement"></Etablissement>
              <Identite v-bind:etablissement="etablissement"></Identite>


            </v-col>
            <v-col lg="4" md="6" sm="12">
             <Synthese></Synthese>
              <FinanceResume></FinanceResume>
              <Risque v-bind:etablissement="etablissement"></Risque>
              <Certificats></Certificats>
              <!--<Cibles></Cibles>-->
              <Concurrence ></Concurrence>


            </v-col>
            <v-col lg="3" md="6" sm="12">
              <EtabAdresse v-bind:etablissement="etablissement"></EtabAdresse>
              <GoogleView></GoogleView>
              <GoogleScore v-bind:etablissement="etablissement"></GoogleScore>
            </v-col>
          </v-row>
        </v-container>


</template>


<script>

import EtabAdresse from '@/components/etablissement/EtabAdresse';
//import EtabBilansINPI from '@/components/etablissement/EtabBilansINPI';
import GoogleView from '@/components/etablissement/EtabGoogleView';
import GoogleScore from '@/components/etablissement/EtabGoogleScore';
import Risque from '@/components/etablissement/EtabSyntheseRisque';
import FinanceResume from '@/components/etablissement/EtabFinanceResume';
import Etablissement from '@/components/etablissement/EtabEtablissement';
import UniteLegale from '@/components/etablissement/EtabUniteLegale';
import Synthese from "@/components/etablissement/EtabSynthese";
import Certificats from "@/components/etablissement/EtabSyntheseCertificats";
import Identite from "@/components/etablissement/EtabIdentite";
// import Cibles from "@/components/etablissement/EtabCibles";
import Concurrence from "@/components/etablissement/EtabConcurrence";


export default {
  name: 'EtabHeader',
  props: ['etablissement'],
  components: {
    Synthese,
    EtabAdresse,
     // EtabBilansINPI,
      GoogleView, GoogleScore, Risque, FinanceResume, Etablissement,
    UniteLegale,Certificats,Identite, Concurrence
  },
  computed: {
    identite: function () {
      return this.$store.getters.getbloc("identite", "donnees")
    },
    nom: function () {
      return this.$store.getters.getbloc("identite", "donnees").nom.valeur
    },
    detail: function () {
      return this.$store.getters.getbloc("administratif", "donnees","categorieJuridiqueUniteLegaleNiv1", "").libelle
    },
    cree: function () {
      return this.$store.getters.getbloc("administratif", "donnees","dateCreationEtablissement", "1900-01-01").libelle
    },
    pp: function () {
      return this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PP"
    },
    pm: function () {
      return this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PM"
    },
    siege: function () {
      return this.$store.getters.getbloc("administratif", "donnees").etablissementSiege.valeur == "true" && this.pm
    },
    administratif: function () {
      return this.$store.getters.getbloc("administratif", "donnees")
    },
    contact: function () {
      return this.$store.getters.getbloc("contact", "donnees")
    },


    defaillance: function () {
      var defaillance = this.$store.getters.getbloc("finance", "indicateurs", "defaillanceGratuit")
      if (defaillance != null && defaillance.libelle != null && defaillance.libelle != "") {
        return defaillance.libelle
      }
      return ""
    },
    couleurDefaillance: function () {
      if (this.defaillance != "") {
        return "red"
      }
      return "white"
    },
    nature: function () {
      if (this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PP") {
        return "mdi-account"
      } else if (this.$store.getters.getbloc("administratif", "donnees").etablissementSiege.valeur == "true") {
        return "mdi-office-building-marker-outline"
      } else {
        return "mdi-office-building-outline"
      }
    },
    tooltipNature: function () {
      if (this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PP") {
        return "Personne physique"
      } else if (this.$store.getters.getbloc("administratif", "donnees").etablissementSiege.valeur == "true") {
        return "Personne morale Siège"
      } else {
        return "Personne morale"
      }


    }

  },
  methods: {
    condition() {
      return this.$store.getters.condition("identite", "donnees")
    },
  }
};
</script>